import React from 'react';

interface DialogBackdropProps {
  onClose: () => void;
}

export const DialogBackdrop: React.FC<DialogBackdropProps> = ({ onClose }) => {
  return <div className="fixed inset-0 bg-black/50 z-40" onClick={onClose} />;
};
